import React, { Component } from 'react';
import Radio from 'common/domain/radio';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { withTheme } from 'styled-components';
import { CentralMarket } from '../domain/CentralMarket';
import { getRadio } from '../../authentication/session/reducers/sessionReducer';
import CentralMarketService from '../services/CentralMarketService';
import DropDownMenu from '../../../../common/components/DropDownMenu';

type Props = {
  radio: Radio,
  selectedCentralMarket?: CentralMarket,
  onSelectCentralMarket: (centralMarket?: CentralMarket) => void,
  withCard: boolean,
  style?: Object,
  t: any,
};

type State = {
  centralMarkets: Array<CentralMarket>,
  currentCentralMarket?: CentralMarket,
  error?: Object,
  isFetching: boolean,
};


export class RadioCentralMarketDropdown extends Component<Props, State> {

  constructor(props) {
    super(props);
    this.state = {
      centralMarkets: [],
      currentCentralMarket: undefined,
      error: undefined,
      isFetching: false,
    };
  }

  async componentDidMount() {
    await this.fetchCentralMarkets();
    this.setSelectedCentralMarket();
  }

  async componentDidUpdate(prevProps: Props) {
    const { radio } = this.props;

    if (!prevProps.radio.isSame(radio)) {
      await this.fetchCentralMarkets();
      this.setSelectedCentralMarket();
    }

    if (prevProps.selectedCentralMarket !== this.props.selectedCentralMarket) {
      this.setSelectedCentralMarket();
    }
  }

  setSelectedCentralMarket() {
    if (!this.props.selectedCentralMarket) {
      this.setState({ currentCentralMarket: undefined });
    } else {
      const centralMarket = this.state.centralMarkets.find(c => c.reference === this.props.selectedCentralMarket.reference);
      this.setState({ currentCentralMarket: centralMarket });
    }
  }

  async fetchCentralMarkets() {
    const { radio } = this.props;
    this.setState({ isFetching: true });

    try {
      const centralMarkets = await CentralMarketService.fetchCentralMarkets(radio.callSign);
      this.setState({ centralMarkets, isFetching: false });
    } catch (error) {
      this.setState({ error, loading: false });
    }
  }

  generateDropdownItems(): Object[] {
    const { centralMarkets } = this.state;

    const fullMarket = [{ key: 'full', label: this.props.t('full'), value: undefined }];
    const markets = centralMarkets.map(centralMarket => ({
      key: centralMarket.reference,
      label: centralMarket.name,
      value: centralMarket,
    }));
    return fullMarket.concat(markets);
  }

  render() {
    if (this.props.withCard) {
      return this.renderCardDropDown();
    }
    return this.renderSelectDropDown();
  }

  renderSelectDropDown() {
    const { theme, style } = this.props;
    const { currentCentralMarket } = this.state;
    return (
      <SelectField
        id={'RADIO_CENTRAL_MARKET_DROPDOWN'}
        value={currentCentralMarket}
        style={{ width: '100%', textAlign: 'left', ...style }}
        underlineStyle={{ height: 1 }}
        selectedMenuItemStyle={{
          color: theme.colors.primary,
          fontSize: '1rem',
        }}
        labelStyle={{
          color: theme.colors.primaryText,
          fontSize: '1rem',
        }}
        menuItemStyle={{
          color: theme.colors.primaryText,
          fontSize: '1.1rem',
        }}
        onChange={(e, i, value) => this.props.onSelectCentralMarket(value)}
      >
        {this.generateDropdownItems().map(market =>
          <MenuItem key={market.key} value={market.value} primaryText={market.label} />,
        )}
      </SelectField>
    );
  }

  renderCardDropDown() {
    const { theme } = this.props;
    const { currentCentralMarket } = this.state;
    return (
      <DropDownMenu
        items={this.generateDropdownItems()}
        onChange={value => this.props.onSelectCentralMarket(value)}
        textColor={theme.colors.primaryText}
        selectedTextColor={theme.colors.primary}
        value={currentCentralMarket}
      />
    );
  }
}

function mapStateToProps(state: *) {
  return {
    radio: getRadio(state),
  };
}

export default translate('centralMarkets')(connect(mapStateToProps)(withTheme(RadioCentralMarketDropdown)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/centralMarkets/components/RadioCentralMarketDropdown.js